@if (showAppConfigMobileWarning$ | async) {
  <!-- mobile placeholder -->
  <rk-mobile-access-warning></rk-mobile-access-warning>
} @else {
  <!-- onboarding modal -->
  <rk-onboarding-modal
    [name]="onboardingModalName$ | async"
    [showModal]="showOnboardingModal$ | async"
  ></rk-onboarding-modal>

  <!-- desktop screen-->
  <div class="w-full h-full flex justify-between" [@fadeInOut]>
    <!-- left panel -->
    <div
      class="w-96 h-full bg-white overflow-hidden flex flex-col justify-between relative left-panel rounded"
    >
      <rk-settings-category-list></rk-settings-category-list>
      <rk-add-new-page></rk-add-new-page>
    </div>
    <!-- simulator -->
    <div class="w-full h-full bg-white flex-1 flex justify-center items-center">
      <rk-simulator></rk-simulator>
    </div>
    <!-- right panel -->
    <div
      class="w-[448px] h-full bg-white overflow-y-scroll overflow-x-hidden rounded right-panel"
      cdkScrollable
      [ngSwitch]="activeSettingsCategory$ | async"
    >
      @switch (activeSettingsCategory$ | async) {
        @case ('general') {
          <rk-general-configuration></rk-general-configuration>
        }
        @case ('menu') {
          <rk-menu-configuration-shell> </rk-menu-configuration-shell>
        }
        @case ('pages') {
          <div>
            @switch (activePageType$ | async) {
              @case ('radio') {
                <rk-player-configuration-shell> </rk-player-configuration-shell>
              }
              @case ('reveil') {
                <rk-alarm-configuration></rk-alarm-configuration>
              }
              @case ('dedicacesaudio') {
                <rk-audio-dedications-configuration></rk-audio-dedications-configuration>
              }
              @case ('rss') {
                <rk-other-pages-configuration></rk-other-pages-configuration>
              }
              @case ('dedicaces') {
                <rk-other-pages-configuration
                  [type]="'dedicaces'"
                ></rk-other-pages-configuration>
              }
              @case ('livefeed') {
                <rk-other-pages-configuration
                  [type]="'livefeed'"
                ></rk-other-pages-configuration>
              }
              @case ('site') {
                <rk-other-pages-configuration
                  [type]="'site'"
                ></rk-other-pages-configuration>
              }
              @case ('podcasts') {
                <rk-podcast-configuration></rk-podcast-configuration>
              }
              @case ('html') {
                <rk-html-page-configuration></rk-html-page-configuration>
              }
              @case ('ckoi') {
                <rk-song-history-configuration></rk-song-history-configuration>
              }
            }
          </div>
        }
      }
    </div>
  </div>
}
